/**
 * @constructor
 * @returns {MadnesServer}
 */
import {round_running, server_config, server_result} from "../../../framework/src/engine/madnes/madnes_variables";

export function MadnesServer() {

	/** @type {*} */
	// this._server_end_round_tmp;
};

MadnesServer.prototype.getConfig = function() {
	return server_config;
};

/**
 * @returns {undefined|string}
 */
MadnesServer.prototype.getSessionId = function() {
	if(server_config) {
		return server_config['session_id']
	}

	return;
};


MadnesServer.prototype.getResult = function() {
	return server_result;
};

// /**
//  * Sends 'create new round' request (PUT)
//  * @returns {Promise}
//  */
// MadnesServer.prototype.loadResult = function(roundData) {
// 	return new Promise(function(res) {
// 		madnes_load_result(roundData, res);
// 	});
// };

// /**
//  * Handles new player`s pick (PUT)
//  * @param {number} pickId
//  * @param {Object} data
//  * @returns {Promise}
//  */
// MadnesServer.prototype.playersPick = function(pickId, data) {
// 	return new Promise(function(res) {
// 		madnes_players_pick(pickId, data, res);
// 	});
// };
//
// MadnesServer.prototype.getPlayersPick = function() {
// 	return server_pick;
// };

// /**
//  * @param {boolean} ended
//  * @param {Object=} roundData
//  * @param {Object=} fsData
//  * @returns {Promise}
//  */
// MadnesServer.prototype.endRound = function(ended, roundData, fsData) {
// 	var _self = this;
// 	return new Promise(function(res) {
// 		madnes_end_round(ended, roundData, fsData, function() {
// 			_self._server_end_round_tmp = server_end_round;
// 			res();
// 		});
// 	});
// };

// MadnesServer.prototype.getEndRoundTmp = function() {
// 	return this._server_end_round_tmp;
// };

// /**
//  * Load symbols in madnes_ajax ?
//  * @param {boolean} bool
//  */
// MadnesServer.prototype.setConfigLoadSymbols = function(bool) {
// 	madnes_config_load_symbols = bool;
// };


MadnesServer.prototype.roundRunning = function() {
	return round_running;
};

/**
 * @param {boolean} bool
 */
MadnesServer.prototype.setRoundRunning = function(bool) {
	round_running = bool;
};

/*MI = MI || {};
MI.server = MadnesServer;*/